'use client'

import React, { useState } from 'react';
import Slider from 'react-slick';
import PropTypes from 'prop-types'
import LineStroke from './line-stroke';
import Image from 'next/legacy/image';

const Steps = ({ steps, images, heading, description }) => {

    const [currentSlide, setCurrentSlide] = useState(0)

    return (
        <section className="relative z-10 flex flex-col gap-8 md:gap-12 items-start justify-center w-full mb-20 md:mb-28 last:mb-10 max-w-7xl mx-auto">
            <div className="w-full max-w-5xl text-center text-xl mx-auto px-4 lg:px-0">
                <div className="relative mb-5 max-w-[200px] text-center mx-auto">
                    <LineStroke />
                </div>
                <h1 className="mb-3 md:text-custom-32 text-black text-3xl leading-10 font-bold max-w-3xl mx-auto">
                    {heading}
                </h1>
                {description}
            </div>
            <div className="w-full flex md:flex-wrap flex-nowrap items-center justify-between gap-8">
                <div className="w-full min-w-[576px] sm:min-w-full max-w-[576px] md:mx-auto px-4 md:px-0">
                    {steps?.map((step, index) => (
                        <div key={step?.id} className={`w-full flex gap-4 h-full group transition-all duration-500 border-l-4 pl-6 py-5 ${currentSlide === index ? "border-red-500" : "border-[#EAECF1]"} md:border-none px-4 lg:px-0`}>
                            <div className="hidden md:flex justify-center items-center">
                                <div className="w-10 h-10 flex items-center justify-center text-[#EB532E] font-semibold rounded-full border-[6px] !border-[#FFF7F0] bg-[#FFECDB] transition-all duration-200">
                                    {step.id}
                                </div>
                            </div>
                            <div className="relative w-full flex flex-col">
                                <div className="relative flex md:flex-col flex-row gap-2 w-full mb-1 md:text-lg text-xl font-semibold">
                                    {step.time && (
                                        <div className={`relative w-fit flex items-center gap-1 ${currentSlide === index ? "bg-[#EB532E]" : "bg-[#FFF3F0]"} py-1 px-3 rounded-full transition-all duration-500 badge`}>
                                            <svg className='mt-[-2px]' xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"><path fill="none" stroke={currentSlide === index ? "#ffffff" : "#454545"} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m19 12l-6-6m6 6l-6 6m6-6H5" /></svg>
                                            <div className={`text-xs leading-none ${currentSlide === index ? "text-white" : "text-[#EB532E]"} transition-all duration-500`}>
                                                {step.time}
                                            </div>
                                        </div>
                                    )}
                                    <div>{step.title}</div>
                                </div>
                                <div className="w-full relative text-base text-secondary">
                                    {step.description}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                <div className='relative md:hidden block w-full overflow-hidden mr-2'>
                    <Slider
                        infinite
                        autoplay
                        swipe={false}
                        autoplaySpeed={5000}
                        beforeChange={(_, next) => setCurrentSlide(next)}
                        className='max-h-[512px] h-[32rem] max-w-[676px] md:hidden flex overflow-hidden'
                    >
                        {images?.map((img, i) => (
                            <div key={i} className='w-full h-full'>
                                <Image
                                    priority
                                    fetchPriority='low'
                                    alt={`image - ${i + 1}`}
                                    src={img}
                                    layout='responsive'
                                    className='object-cover'
                                    width={10}
                                    height={10}
                                />
                            </div>
                        ))}
                    </Slider>
                </div>

            </div>
            <div className="relative w-full md:flex hidden h-[440px] sm:h-[250px]">
                <Image
                    priority
                    fetchPriority='low'
                    alt={"onboarding"}
                    src={"/images/onboarding.webp"}
                    layout='fill'
                    className='object-cover'
                />
            </div>
        </section>
    );
};

Steps.propTypes = {
    images: PropTypes.array,
    steps: PropTypes.array,
    heading: PropTypes.array,
    description: PropTypes.array,
}

export default Steps;